import type { ICampaignPickItemInteraction } from '../../types';

import { CAMPAIGN_PICK_ITEM_GROUP_CLASS } from '../../constants';
import { GTooltip } from '~/presentation/ui';
import { Box } from '@shopify/polaris';
import { cls } from '~/utils';

interface IProps {
  children: React.ReactNode;
  interaction?: ICampaignPickItemInteraction;
  className?: string;
}

/**
 * Row shell shared by the pick-resource modals: the hover tooltip, the disabled background and the
 * hover group the row's shortcut actions hang off.
 */
export const CampaignPickItemRow: React.FC<IProps> = ({ children, interaction, className }) => (
  <GTooltip content={interaction?.tooltipContent}>
    <div className={cls(CAMPAIGN_PICK_ITEM_GROUP_CLASS, 'relative', className)}>
      {/* A disabled ResourceItem swallows pointer events, so an invisible activator keeps the
          tooltip reachable on hover. */}
      {!!interaction?.tooltipContent && (
        <input
          aria-hidden
          tabIndex={-1}
          readOnly
          className="pointer-events-none absolute inset-0 opacity-0"
        />
      )}
      <Box
        borderColor="border"
        borderBlockEndWidth="0165"
        background={interaction?.isDisabled ? 'bg-surface-disabled' : undefined}
      >
        {children}
      </Box>
    </div>
  </GTooltip>
);
